import React from 'react';
import WithConsumer from "../context/WithConsumer";
import {ClipLoader} from "react-spinners";
import NotFound from "../templates/NotFound";


/**
 *
 */
class Page extends React.PureComponent {

    /**
     * @returns {*}
     */
    render = () => {

        const {context} = this.props;
        const data = context.getPageData();

        if (!data && !context.loading) {
            return (<NotFound/>);
        }

        return (
            <div className='Container Container--tall'>
                {context.loading && (
                    <div className='Loader'>
                        <ClipLoader size={40}/>
                    </div>
                )}
                {!context.loading && (
                    <div className='Page'>
                        <div
                            className='Page__panel'
                            dangerouslySetInnerHTML={{__html: data.acf.panel}}
                        />
                        <div
                            className='Page__content'
                            dangerouslySetInnerHTML={{__html: data.content.rendered}}
                        />
                    </div>
                )}
            </div>
        );
    };
}

export default WithConsumer(Page);